import type { PGDExclusionCheckNode } from "../types";

export function getPgdExclusionCheckPgdId(
  node: PGDExclusionCheckNode | null | undefined,
  selectedPgdId: string | null,
): string | null {
  return node?.pgdIdOverride || selectedPgdId;
}

export function shouldSelectOverridePgd(
  node: PGDExclusionCheckNode | null | undefined,
  anyExclusionTriggered: boolean,
): boolean {
  return Boolean(node?.pgdIdOverride && !anyExclusionTriggered);
}
